var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('toast',{ref:"toast",attrs:{"text":_vm.text,"textBgColor":"rgba(58,58,58,.9) !important"}}),_c('full-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFullLoading),expression:"showFullLoading"}],attrs:{"title":_vm.fullLoadingText}}),_c('wxtip',{attrs:{"show":_vm.showwxtip}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }